import { Feature } from '@/types/feature'
import { FeatureLink } from '@/components/feature/FeatureLink'
import { FeatureImage } from '@/components/feature/FeatureImage'
import { FeatureDetail } from '@/components/feature/FeatureDetail'
interface Props {
  feature: Feature
}
export const FeatureXs: React.FC<Props> = ({ feature }) => {
  const { id, title } = feature
  return (
    <div className="relative p-1 my-4 w-1/2 sm:w-1/4">
      <FeatureImage id={`${id}`} title={title} />
      <FeatureDetail feature={feature} />
      <FeatureLink type="diagnosis" address={feature.address} />
    </div>
  )
}
